import React from "react";
import { useI18n } from "@/lib/i18n";

export default function StatusChip({ status, testId }) {
  const { t } = useI18n();
  const cls =
    status === "FOUND" ? "bp-chip bp-chip--found" :
    status === "PARTIAL" ? "bp-chip bp-chip--partial" :
    status === "NOT_ASSESSABLE" ? "bp-chip bp-chip--notassessable" :
    "bp-chip bp-chip--notfound";
  const dot =
    status === "FOUND" ? "#2E7D32" :
    status === "PARTIAL" ? "#B97700" :
    status === "NOT_ASSESSABLE" ? "#5A7A9A" :
    "#9E9E9E";
  return (
    <span className={cls} data-testid={testId || `status-chip-${status}`}>
      <span aria-hidden style={{
        width: 6, height: 6, borderRadius: 999,
        background: dot,
      }} />
      {t.status[status] || status}
    </span>
  );
}
